"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenServiceApi = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _gen = require("../gen");
var _interceptor = require("../interceptor");
class TokenServiceApi extends _gen.TokenServiceApi {
  constructor(configuration, basePath, axiosInstance = _axios.default.create()) {
    const cb = (0, _interceptor.withCircuitBreaker)({
      name: "TokenServiceApi",
      maxRequests: 1,
      timeout: 10000,
      failuresThreshold: 5,
      failureStatusCodes: [502, 503, 504]
    });
    axiosInstance.interceptors.request.use(cb.request);
    axiosInstance.interceptors.response.use(cb.response, cb.error);
    super(configuration, basePath, axiosInstance);
  }
}
exports.TokenServiceApi = TokenServiceApi;
//# sourceMappingURL=TokenServiceApi.js.map